import React, { createContext, useState, useContext, useEffect } from 'react'

const UserContext = createContext()

export function UserProvider({ children }) {
    const [user, setUser] = useState(null)
    const [orgId, setOrgId] = useState(null)
    const [roles, setUserRoles] = useState([])

    useEffect(() => {
        console.log('user', user)
        console.log('orgId', orgId)
        console.log('roles', roles)
    }, [user])

    return (
        <UserContext.Provider
            value={{ user, orgId, setUser, setOrgId, roles, setUserRoles }}
        >
            {children}
        </UserContext.Provider>
    )
}

export function useUser() {
    return useContext(UserContext)
}
